import { NgModule } from '@angular/core';
import { AceEditorDirective } from './ng-ace.directive';
export {
  AceEditorDirective
};
export class AceEditorModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    AceEditorDirective
  ],
  exports: [
    AceEditorDirective
  ],
  providers: [

  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function AceEditorModule_tsickle_Closure_declarations() {
/** @type {?} */
AceEditorModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AceEditorModule.ctorParameters;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
